import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '@actions';
import { getLogger } from 'loglevel';

const log = getLogger(__filename);

const useGDPRConfirmation = (appointment, appointmentOutcome, appointmentMeta) => {
  const dispatch = useDispatch();
  const [needsGDPREmailSending, setNeedsGDPREmailSending] = useState(false);
  const [sent, setSent] = useState(false);

  // todo - error handling??
  const sendGDPREmail = useCallback(async () => {
    const res = await dispatch(actions.sendGDPREmail(appointment.patient_user_guid, appointment.appointment_id));

    if ('email_id' in res && res.email_id) {
      setSent(true);
    } else {
      log.log('Clicked', res);
    }

    return res;
  }, [dispatch, appointment]);

  useEffect(() => {
    if (appointmentOutcome && appointmentMeta) {
      const outcomeMeta = appointmentMeta.find((o) => o.appt_outcome_code === appointmentOutcome);
      setNeedsGDPREmailSending(outcomeMeta?.appt_gdpr_flag);
    }
  }, [appointmentOutcome, appointmentMeta]);

  return { needsGDPREmailSending, sendGDPREmail, GDPRConfirmationSent: sent };
};

export default useGDPRConfirmation;
